import { AxiosRequestHeaders } from 'axios';
import axiosObject, { authAxios } from './axios';

export const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8007';

export type MakeRequest = {
  url: string;
  method: string;
  data?: unknown;
  params?: unknown;
  headers?: AxiosRequestHeaders;
  signal?: AbortSignal;
  isAuthRequest?: boolean;
};

export const makeRequest = async (req: MakeRequest) => {
  const { url, method, data, params, headers, signal, isAuthRequest } = req;
  const axiosInstance = isAuthRequest ? authAxios : axiosObject;
  return axiosInstance({
    url: baseURL + url,
    method,
    data,
    params,
    headers,
    signal,
  }).then((res: any) => res.data);
};
